"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _sortedIndex = _interopRequireDefault(require("./sortedIndex.js"));

var _findIndex = _interopRequireDefault(require("./findIndex.js"));

var _createIndexFinder = _interopRequireDefault(require("./_createIndexFinder.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
var _default = (0, _createIndexFinder.default)(1, _findIndex.default, _sortedIndex.default);

exports.default = _default;